<template>
  <div>
    <div class="ts-flex">
      <div class="ts-relative ts-w-full">
        <input
          v-model.trim="search"
          ref="search"
          type="text"
          class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
          :placeholder="$t('promotion.searchProduct')"
        />
        <span
          class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2"
          style="margin-top: 7px"
          ><i class="fa fa-search"></i
        ></span>
      </div>
    </div>
    <br />
    <div class="max-h ts-px-3">
      <table class="ts-w-full">
        <tr
          class="ts-border-b ts-border-gray-400"
          v-for="(product, index) in getProduct({
            chosenProduct: model.product_id_list,
            search: search
          })"
          :key="index"
        >
          <td class="ts-text-xs">{{ product.barcode }}</td>
          <td class="ts-text-xs">{{ product.product_name_en }}</td>
          <td class="ts-text-xs">{{ product.product_name_kh }}</td>
          <td class="ts-px-4">
            {{
              getPrice(product.product_id, getDefaultUom(product.product_id))
            }}
          </td>
          <td style="width: 1%" class="text-center ts-pl-4">
            <a
              href="#"
              v-tooltip="$t('add')"
              @click.prevent="addItem(product)"
              class="ts-mb-0"
            >
              <i class="fa fa-plus"></i>
            </a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'product-list',
  props: ['value'],
  data () {
    return {
      search: '',
      model: {}
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    ...mapGetters('restaurantSale/productPriceSchema', [
      'getProduct',
      'getPrice',
      'getDefaultUom'
    ])
  },
  methods: {
    addItem (product) {
       this.model.product_id_list.push({
        barcode: product.barcode,
        product_name_en: product.product_name_en,
        product_name_kh: product.product_name_kh,
        product_id: product.product_id,
        unit_price: this.getPrice(product.product_id, this.getDefaultUom(product.product_id)),
        uom_id: this.getDefaultUom(product.product_id)
      })
    }
  }
}
</script>

<style scoped>
.max-h {
  height: 400px;
  max-height: 500px;
  overflow: scroll;
}
</style>
